import {
  Mutation,
  SetupDirectDepositError,
  SetupDirectDepositResultTypenames,
} from '@varo/graphql-schema-types';
import { useCallback, useEffect } from 'react';
import SetupDirectDeposit from 'services/graphql/mutations/MoveMoney/SetUpDirectDeposit';
import { useMutation } from 'urql';

interface UseSetupDirectDepositOutput {
  fetching: boolean;
  pdfURL: string;
  error: Error | undefined;
  directDepositError: SetupDirectDepositError | null;
  reTry: () => void;
}

export const useSetupDirectDeposit = (
  accountId?: string,
): UseSetupDirectDepositOutput => {
  const [{ fetching, data, error }, executeSetupDirectDeposit] =
    useMutation<Mutation>(SetupDirectDeposit);

  const fetchDepositFormFromServer = useCallback(() => {
    if (!accountId) {
      return;
    }

    void executeSetupDirectDeposit({
      input: {
        accountId,
        directDepositForm: 'ONE_TAP',
      },
    });
  }, [accountId, executeSetupDirectDeposit]);

  useEffect(() => {
    fetchDepositFormFromServer();
  }, [fetchDepositFormFromServer]);

  const directDepositError =
    data?.setupDirectDeposit?.__typename ===
    SetupDirectDepositResultTypenames.SetupDirectDepositError
      ? data.setupDirectDeposit
      : null;

  return {
    fetching,
    pdfURL:
      data?.setupDirectDeposit.__typename ===
      SetupDirectDepositResultTypenames.SetupDirectDepositSuccess
        ? data.setupDirectDeposit.url
        : '',
    error,
    directDepositError,
    reTry: fetchDepositFormFromServer,
  };
};
